import "./style.css";

const LoadingFull = (props) => {
	return (
		<div className="loading-overlay d-flex justify-content-center align-items-center">
			<div>
				<span className="spinner-grow spinner-grow-sm text-color me-2" role="status"></span>
				<span>{props.mensagem}</span>
			</div>
		</div>
	);
};

export default LoadingFull;
